import { Component, OnInit, EventEmitter, Output, ViewChild, TemplateRef, Input } from '@angular/core';
import { BillingListModel } from 'src/app/models/billing-address.model';
import { CountriesListModel } from 'src/app/models/countries-list.model';
import { UserDetails } from 'src/app/models/user-details.model';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { BillingAddressService } from 'src/app/services/billing-address/billing-address.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';

@Component({
  selector: 'ipm-billing-addresses',
  templateUrl: './billing-addresses.component.html',
  styleUrls: ['./billing-addresses.component.scss']
})
export class BillingAddressesComponent implements OnInit {
  billingAddressList: Array<BillingListModel> = [];
  @Input() isSelectEventTrigger: boolean = true;
  @Input() isDefaultSelected: boolean = false;
  @Input() isShowAction: boolean = false;
  @Input() isShowCompanyName: boolean = false;
  @Input() isShowScrollbar: boolean = false;
  @Input() isShowAll: boolean = false;
  @Input() disableAutoPopup: boolean = false;
  @Input() defaultDialogType: string = "";
  isShowAllData: boolean = false;
  countries: Array<CountriesListModel> = [];
  private hasAutoOpened: boolean = false;
  @Output() onSelectedData: EventEmitter<any> = new EventEmitter();
  @Output() gotoDashBoard: EventEmitter<any> = new EventEmitter();
  @Output() checkBillingList: EventEmitter<any> = new EventEmitter();
  @Output() addNewClicked: EventEmitter<void> = new EventEmitter();
  @Input() isInsidePopup: boolean = false;
  @ViewChild('addressModel' , { static :  false}) addressModelTemplate: TemplateRef<any>;
  dialogType: string = ""
  currentUserDetails: UserDetails;
  constructor(private billingService: BillingAddressService,
    private commonService: CommonService,
      private ga4TrackingService: Ga4trackingService,
  private authService: AuthService,
  public browserStorageService: BrowserStorageService) {}

  ngOnInit(): void {
    this.getCountries();
    this.getAddress();
    this.authService.currentUserDetails.subscribe( userObj => {
      if (Object.keys(userObj).length > 0) {
        this.currentUserDetails = userObj;
      } 
     })
  }

  /**
   * get Counter
   */
  getCountries() {
    this.countries = this.commonService.getCountriesList();
  }

  handleAddClick() {
    if (this.isInsidePopup) {
      this.addNewClicked.emit();
    } else {
      this.openAddressPop('', this.defaultDialogType);
    }
  }



  /**
   * Get Address List Api Methods
   */
  getAddress() {
    this.billingAddressList = [];
    this.commonService.billingAddressEvent.subscribe( ( billingList: Array<BillingListModel> ) => {
      if (billingList.length > 0) {
        this.billingAddressList = [...billingList].reverse(); 
        if (this.isDefaultSelected) {
          let sendData: any = {
            currentBillingAddress: this.billingAddressList[0], 
            actionCalling: this.dialogType
          }
          this.billingAddressList.filter((item: any,i: number) => {
            if (i === 0) {
              this.onSelectedData.emit(sendData);
              item.isSelected = true;
            } else {
              item.isSelected = false;
            }
            return item;
          });
          
        }
      } else if (billingList.length === 0 && !this.hasAutoOpened && !this.disableAutoPopup) {
        // No addresses exist, open form directly but only once
        this.hasAutoOpened = true;
        setTimeout(() => {
          this.openAddressPop();
        }, 1);
      }
      
      this.checkBillingList.emit(billingList.length);
    }, (error: any) => {
      this.commonService.showToastError(error);
    })
  }

  /**
   * open Address Pop
   */
  openAddressPop(index: any = "", type: string = "") {
    this.dialogType = type;
    this.commonService.closePopUp();
    let senData: any = {}; 
    if (this.billingAddressList[index]) {
      senData = this.billingAddressList[index]
    }
    let eventName = "add_new_billing_address_initiated";
    this.ga4TrackingService.sendEvent(eventName, {
      event_category: 'billing_address_management',
      event_label: "open_billing_address_form_popup",
      userRole: this.browserStorageService?.getCurrentRoles() || 'guest'
    });
    let className  = this.commonService.isMobileDisableClick ? 'ipm-mobile-address-model' : 'ipm-address-model' ;
    this.commonService.openModel(this.addressModelTemplate, senData, className);
    if (!this.commonService.isMobileDisableClick) {
      this.commonService.modelRef.afterClosed().subscribe( res => {
        this.addDataOnClose(res, index);
      });  
    } else {
      this.commonService.bottomRef.afterDismissed().subscribe( res => {
        this.addDataOnClose(res, index);
      });
    }
  }

  /**
   * add data on close address popup
   * @param res 
   */
  addDataOnClose(res:any, currentIndex: any) {
    if (res &&  Object.keys(res).length) {
        if (currentIndex !== null &&  currentIndex !== "" &&  currentIndex !== undefined) {
            this.billingAddressList[currentIndex] =  res;
            if (this.dialogType === "checkoutType") {
              this.selectedData(0)
            }
        } else {
          this.billingAddressList.reverse();
          this.billingAddressList.push(res);
          if (this.dialogType === "checkoutType") {
            // Select the newly added address (which is at the end of the array)
            this.selectedData(this.billingAddressList.length - 1);
          }
        }
        // Address was added, reset flag for future use
        this.hasAutoOpened = false;
        this.commonService.billingAddressEvent.next(this.billingAddressList);
        setTimeout(() => {
          this.gotoDashBoard.emit([res]);
        });
    }
    if(!this.hasAutoOpened)this.commonService.selectAddressPopupEvent.emit("true");

  }

  /**
   * On click selected  billing address
   * @param index 
   */
  selectedData(index: any) {
    if (this.isSelectEventTrigger) {
      if (index === "") {
        this.onSelectedData.emit("");
      } else {
        this.billingAddressList.map( (item:BillingListModel, i:number) => {
          if (i === index) {
            let sendData = {
              currentBillingAddress: item, 
              actionCalling: this.dialogType
            }
            this.onSelectedData.emit(sendData);
            item.isSelected = true;
          } else {
            item.isSelected = false;
          }
        });
      }
    }
  }

  /**
   * delete address list
   * @param data 
   */
  deleteBeat(index:any) {
    let billingObj: any = this.billingAddressList[index];
    if (billingObj) {
      this.billingService.deleteBillingAddress(billingObj._id).subscribe(res => {
        const INDEX =  this.billingAddressList.findIndex( item => item._id === billingObj._id);
        if (INDEX > -1) {
          this.billingAddressList.splice(INDEX,1);
        }
        if (this.billingAddressList.length === 0) {
          this.selectedData("");
        }
      }, (error) => {
        this.commonService.showToastError(error);
      });
    }
  }

  onClickShow() {
    this.isShowAllData = this.isShowAllData ? false :  true;
  }

}
